 function setCookie(cname, cvalue, days) {
    const d = new Date();
    d.setTime(d.getTime() + (days*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }

  var today = new Date();
  var  countDownDate = new Date(today.getTime() + 300000).getTime();

  var now = new Date().getTime();
  var gtcooki =  getCookie("all_products_template");
  if(gtcooki == null){
    setCookie("all_products_template",countDownDate,1);
    setTimeout(function(){
      document.querySelectorAll('.product-sale-popup')[0].classList.add('open-popup');
      document.body.classList.add('overflow-hidden');
    },2000);
  }
  else{
    var  countDownDate = gtcooki;
    if((countDownDate - now) > 0){
      document.querySelectorAll('.amz-02-popup-bottom-banner')[0].style.display = 'block';
    }
  }
  document.addEventListener("DOMContentLoaded", (event) => {
  var x = setInterval(function() {
    // Get today's date and time
    var now = new Date().getTime();
    // Find the distance between now and the count down date
    var distance = countDownDate - now;
    // Time calculations for days, hours, minutes and seconds
    //   var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    //   var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    var Milliseconds= Math.floor((distance %( 1000 )) / 10);

    var minutes1 = String(minutes).split('').map(Number);
    var seconds1 = String(seconds).split('').map(Number);
    var Milliseconds1 = String(Milliseconds).split('').map(Number);

    // If the count down is finished, write some text
    if (distance < 0) {
      clearInterval(x);
      document.querySelector(".count-minutes").innerHTML = '<div class="sct-rotor-leaf-front">0</div><div class="sct-rotor-leaf-front">0</div>';
      document.querySelector(".count-seconds").innerHTML = '<div class="sct-rotor-leaf-front">0</div><div class="sct-rotor-leaf-front">0</div>';
      document.querySelector(".count-milliseconds").innerHTML = '<div class="sct-rotor-leaf-front">0</div><div class="sct-rotor-leaf-front">0</div>';
      document.querySelectorAll('.product-sale-popup')[0].classList.remove('open-popup');
      document.body.classList.remove('overflow-hidden');
      document.querySelectorAll('.amz-02-popup-bottom-banner')[0].style.display = 'none';

    }else{
      if (minutes < 10 ) {
        document.querySelector(".count-minutes").innerHTML = '<div class="sct-rotor-leaf-front">0</div><div class="sct-rotor-leaf-front">'+minutes1[0]+'</div>';
      } else {
        document.querySelector(".count-minutes").innerHTML = '<div class="sct-rotor-leaf-front">'+minutes1[0]+'</div><div class="sct-rotor-leaf-front">'+minutes1[1]+'</div>';
      }

      if (seconds < 10 ) {
        document.querySelector(".count-seconds").innerHTML = '<div class="sct-rotor-leaf-front">0</div><div class="sct-rotor-leaf-front">'+seconds1[0]+'</div>';
      } else {
        document.querySelector(".count-seconds").innerHTML = '<div class="sct-rotor-leaf-front">'+seconds1[0]+'</div><div class="sct-rotor-leaf-front">'+seconds1[1]+'</div>';
      }

      if (Milliseconds < 10 ) {
        document.querySelector(".count-milliseconds").innerHTML = '<div class="sct-rotor-leaf-front">0</div><div class="sct-rotor-leaf-front">'+Milliseconds1[0]+'</div>';
      } else {
        document.querySelector(".count-milliseconds").innerHTML = '<div class="sct-rotor-leaf-front">'+Milliseconds1[0]+'</div><div class="sct-rotor-leaf-front">'+Milliseconds1[1]+'</div>';
      }
    }
  });
  });